import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-134b8658"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-wrapper" }
const _hoisted_2 = { class: "tab-title-wrapper" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "tab-content-wrapper" }
const _hoisted_5 = { class: "tab-content-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabInfo.titles, (item, index) => {
        return (_openBlock(), _createElementBlock("span", {
          class: _normalizeClass(["tab-title", {'active':_ctx.tabInfo.currentIndex === index}]),
          ref_for: true,
          ref: _ctx.tabInfo.setTabTitleRefs,
          onClick: ($event: any) => (_ctx.tabInfo.currentIndex = index),
          key: index
        }, _toDisplayString(item), 11, _hoisted_3))
      }), 128)),
      _createElementVNode("div", {
        class: "active-line",
        style: _normalizeStyle({
        width:_ctx.tabInfo.activeLineWidth + 'px',
        transform:'translateX(' + _ctx.tabInfo.activeLineTransformWidth + 'px)'
      })
      }, null, 4)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "tab-move-wrapper",
        style: _normalizeStyle({
         transform:'translateX(-' + (_ctx.tabInfo.currentIndex * 100) + '%)'
      })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabInfo.defaults, (item, index) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(item), { key: item }))
          ]))
        }), 256))
      ], 4)
    ])
  ]))
}